module.exports = __webpack_public_path__ + "img/cfa7d103c217fc61cf84e88e9cbf6be5.png";